import { ListFilter, SearchIcon, X } from "lucide-react";
import React from "react";
import { Button } from "../ui/button";
import { useKanbanFilterStore } from "@/store/zustand/kanbanFilterStore";

type NoResultsProps = {
  isFiltersApplied: boolean;
  isSearchApplied: boolean;
  hiddenCanvases: number;
  projectId: string;
};

const NoResults = ({
  isFiltersApplied,
  isSearchApplied,
  hiddenCanvases,
  projectId,
}: NoResultsProps) => {
  const clearFilters = useKanbanFilterStore((state) => state.clearFilter);

  const getMessage = () => {
    if (isFiltersApplied && isSearchApplied) {
      return "filters and search.";
    }
    if (isFiltersApplied) {
      return "filters.";
    }
    return "search.";
  };

  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-140px)] gap-4 flex-1">
      {getMessage() === "search." ? (
        <SearchIcon
          size={32}
          className="text-icons-primary"
          strokeWidth={0.5}
        />
      ) : (
        <ListFilter size={32} className="text-icons-primary" strokeWidth={1} />
      )}

      <h3 className="text-text-secondary text-lg">
        No canvases matching your {getMessage()}
      </h3>
      <div className="flex justify-between items-center rounded-lg p-2 border border-border-secondary h-9 gap-6">
        <p className="text-xs font-normal text-text-secondary">
          <span className="text-text-primary font-medium">
            {hiddenCanvases} canvases
          </span>{" "}
          {getMessage()}
        </p>
        <Button
          variant="ghost"
          size="sm"
          className="px-2 gap-1 text-text-primary text-xs"
          onClick={() => clearFilters(projectId)}
        >
          Clear all <X size={14} />
        </Button>
      </div>
    </div>
  );
};

export default React.memo(NoResults);
